import { Injectable } from '@angular/core';
import { isEmpty, isString, isNil } from 'lodash';
import { comparators } from './comparators';

@Injectable()
export class NoneValueHelper {

    public static readonly none = 'None';

    public isNone(value: any) {
        return isNil(value) || (isString(value) && isEmpty(value));
    }

    public toDisplay(value: any): string {
        return this.isNone(value) ? NoneValueHelper.none : value;
    }

    public compare(valueA: any, valueB: any) {
        let valueAIsNone = this.isNone(valueA);
        let valueBIsNone = this.isNone(valueB);

        if (valueAIsNone && valueBIsNone) {
            return 0;
        }
        if (valueAIsNone) {
            return -1;
        }
        if (valueBIsNone) {
            return 1;
        }

        return comparators.stringComparator(valueA, valueB);
    }
}